import { render, staticRenderFns } from "./Dashboard copy.vue?vue&type=template&id=2ea58651&"
import script from "./Dashboard copy.vue?vue&type=script&lang=js&"
export * from "./Dashboard copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports